import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../../utils/axios';
import { SUBSCRIBE_PACKAGE_TYPE_LIST } from 'src/constants/queryKeys';

export const networkGetSubscribePackageTypeInfo = async (planetId) => {
  const res = await axiosInstance.post(`SubscribePackageType/Info/${planetId}`);
  return res;
};

export const networkGetSubscribePackageTypeList = async (payload, pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`SubscribePackageType/List/${pageIndex}/${pageSize}/`, payload);
  return res;
};

export function useFetchSubscribePackageTypeList(payload, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: [SUBSCRIBE_PACKAGE_TYPE_LIST, payload, pageIndex],
    queryFn: () => networkGetSubscribePackageTypeList(payload, pageIndex, pageSize),
  });
}

export const networkUpdateSubscribePackageType = async (planetId, payload) => {
  const res = await axiosInstance.post(`SubscribePackageType/Update/${planetId}`, payload);
  return res;
};

export const networkRemoveSubscribePackageType = async (planetId) => {
  const res = await axiosInstance.post(`SubscribePackageType/Remove/${planetId}`);
  return res;
};

export const networkCreateSubscribePackageType = async (payload) => {
  const res = await axiosInstance.post('SubscribePackageType/Insert', payload);
  return res;
};
